/* Options:
Date: 2026-03-13 10:21:57
Version: 6.10
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:44379

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
DefaultImports: immerable:immer
*/

import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export interface IDelete
{
}

export interface IPatch
{
}

export class ConferenceEmail
{
    [immerable] = true;

    public constructor(init?: Partial<ConferenceEmail>) { (Object as any).assign(this, init); }
}

export enum RegistrationSort
{
    Id = 1,
    FirstName = 2,
    LastName = 3,
    ReceiptNumber = 4,
    DateAdded = 5,
    Institution = 6,
    TotalCost = 7,
    TotalOwing = 8,
    DelegateType = 9,
    AffiliationRegistration = 10,
    Status = 11,
}

export enum RegistrationStatus
{
    Registered = 1,
    Unregistered = 2,
    All = 3,
}

export enum DietaryRequirementType
{
    Vegetarian = 1,
    VeganPlantBased = 2,
    Halal = 3,
    Coeliac = 4,
    LactoseIntolerant = 5,
    Pescatarian = 6,
    SpecificFoodAllergy = 7,
}

export enum AdminPaymentType
{
    Cheque = 1,
    ETransferFunds = 2,
    Card = 3,
    Cash = 4,
    Internet = 5,
    MoneyOrder = 6,
    Invoiced = 7,
    Refund = 8,
    StripeApp = 9,
}

export enum CommWebResponseCode
{
    Success = 1,
    Expired = 2,
    InsufficientFunds = 3,
    DeclinedBank = 4,
    DeclinedCommWeb = 5,
    ServerError = 6,
}

export class Payment implements IForm
{
    [immerable] = true;
    public id?: number;
    public repeat?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public paymentOption?: AdminPaymentType;
    public cardType?: string;
    // @Ignore()
    public cardHolderName?: string;

    // @Ignore()
    public cardNumber?: string;

    // @Ignore()
    public expiryMonth?: number;

    // @Ignore()
    public expiryYear?: number;

    // @Ignore()
    public ccv?: string;

    public paymentDate?: string;
    public paymentDateTime?: string;
    public amountPaid?: number;
    public paymentType?: number;
    public cmNumber?: string;
    public bank?: string;
    public bsb?: string;
    public receiptNumber?: string;
    public paymentStatus?: CommWebResponseCode;
    public paymentMessage?: string;
    // @Ignore()
    public attemptNumber?: number;

    // @Ignore()
    public paymentSuccess?: boolean;

    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<Payment>) { (Object as any).assign(this, init); }
}

export class EarlyBirdForm implements IForm
{
    [immerable] = true;
    public id?: number;
    public registrationId?: number;
    public repeat?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public requiresDisabilityAccess?: number;
    public requiresAVAssistance?: number;
    public heardAboutAsm?: number;
    public heardAboutAsmOther?: string;
    public dietaryRequirements?: string;
    public dietaryRequirement?: DietaryRequirementType;
    public title?: number;
    public firstName?: string;
    public lastName?: string;
    public address?: string;
    public suburb?: string;
    public postcode?: string;
    public state?: number;
    public country?: string;
    public phoneNumber?: string;
    public email?: string;
    public speciality?: number;
    public specialitySpec?: string;
    public institution?: string;
    public earlyMidCareer?: boolean;
    public receiveCertificate?: boolean;
    public includeDetails?: boolean;
    public payments?: Payment[];
    public cost?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<EarlyBirdForm>) { (Object as any).assign(this, init); }
}

export class SavePrintJob
{
    [immerable] = true;
    public registrationId?: number;
    public failed?: boolean;
    public printed?: boolean;

    public constructor(init?: Partial<SavePrintJob>) { (Object as any).assign(this, init); }
}

export interface IHeaderDictionary
{
}

export interface IFormFile
{
    contentType?: string;
    contentDisposition?: string;
    headers?: IHeaderDictionary;
    length?: number;
    name?: string;
    fileName?: string;
}

export class AsmPrintSettings
{
    [immerable] = true;
    public printer?: string;
    public labelFilePath?: string;
    public printToFileFolder?: string;

    public constructor(init?: Partial<AsmPrintSettings>) { (Object as any).assign(this, init); }
}

export enum RegistrationAffiliation
{
    Board = 2,
    CAP = 3,
    GuestSpeaker = 4,
    Other = 13,
    TraineeAndEarlyCareersDayGrant = 14,
    EducationTravelGrant = 15,
}

export class RegistrationSession implements IForm
{
    [immerable] = true;
    public id?: number;
    public repeat?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    // @References("typeof(Conference.ServiceLogic.Models.Form.Session)")
    public sessionId?: number;

    public numberOfAttendees?: number;
    public additionalNotes?: string;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<RegistrationSession>) { (Object as any).assign(this, init); }
}

export class RegistrationCancellationList implements IForm
{
    [immerable] = true;
    public id?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public repeat?: number;
    public sessionId?: number;
    public date?: string;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<RegistrationCancellationList>) { (Object as any).assign(this, init); }
}

export class FileUploadTemporary implements IFileUploadTemporary
{
    [immerable] = true;
    public guid?: string;
    public name?: string;
    public extension?: string;
    public fileSize?: number;
    public contentType?: string;
    public image?: boolean;

    public constructor(init?: Partial<FileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class File
{
    [immerable] = true;
    public id?: number;
    public formDefinitionId?: number;
    public formId?: number;
    public propertyName?: string;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;
    // @Ignore()
    public upload?: FileUploadTemporary;

    // @Ignore()
    public extension?: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType?: string;

    // @Ignore()
    public exists?: boolean;

    // @Ignore()
    public image?: boolean;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}

export class SpeakerPresentation implements IForm
{
    [immerable] = true;
    public id?: number;
    public repeat?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public registrationId?: number;
    public presentationTitle?: string;
    public overviewInformation?: string;
    // @Ignore()
    public presentation?: File;

    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<SpeakerPresentation>) { (Object as any).assign(this, init); }
}

export class PlaneTicket implements IForm
{
    [immerable] = true;
    public id?: number;
    public repeat?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public registrationId?: number;
    public name?: string;
    // @Ignore()
    public ticket?: File;

    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<PlaneTicket>) { (Object as any).assign(this, init); }
}

export class Registration implements IForm
{
    [immerable] = true;
    public id?: number;
    public repeat?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public attendanceType?: number;
    public requiresDisabilityAccess?: number;
    public requiresAVAssistance?: number;
    public heardAboutAsm?: number;
    public heardAboutAsmOther?: string;
    public dietaryRequirements?: string;
    public trialCoordinator?: boolean;
    public defaultUser?: boolean;
    public student?: boolean;
    public staff?: boolean;
    public isSac?: boolean;
    public registrationAffiliation?: RegistrationAffiliation;
    public isCap?: boolean;
    public attendeeFromJapanOrKorea?: boolean;
    public sponsorDeleted?: boolean;
    public staffConfirmed?: boolean;
    public registrar?: boolean;
    public supervisorName?: string;
    public sponsor?: boolean;
    public other?: boolean;
    public otherSpecification?: string;
    public freeRegistration?: boolean;
    public freeSponsorRegistration?: boolean;
    public customRegistration?: boolean;
    public customPrice?: number;
    public priceNote?: string;
    public sessions?: RegistrationSession[];
    public cancellationLists?: RegistrationCancellationList[];
    public title?: number;
    public firstName?: string;
    public lastName?: string;
    public address?: string;
    public suburb?: string;
    public postcode?: string;
    public state?: number;
    public country?: string;
    public phoneNumber?: string;
    public email?: string;
    public speciality?: number;
    public specialitySpec?: string;
    public institution?: string;
    public earlyMidCareer?: boolean;
    public includeDetails?: boolean;
    public receiveCertificate?: boolean;
    public cost?: number;
    public additionalCost?: number;
    public amountOwing?: number;
    public packageId?: number;
    public member?: number;
    public delegateType?: number;
    public attendanceTypeForLabel?: string;
    public deleted?: boolean;
    public registered?: boolean;
    public sponsorId?: number;
    public payments?: Payment[];
    public invoiceNumber?: string;
    public invoiceSent?: boolean;
    public hotelName?: number;
    public certificatePending?: boolean;
    public certificateDate?: string;
    public affiliation?: number;
    public accomType?: number;
    public roomBuddy?: string;
    public hotelCheckin?: string;
    public hotelCheckout?: string;
    public postalStreet?: string;
    public postalSuburb?: string;
    public postalState?: string;
    public postalPostcode?: string;
    public mobile?: string;
    public originCity?: string;
    public bctFlights?: number;
    public flightArrival?: string;
    public flightDeparture?: string;
    public bctTransfers?: number;
    public airportTransfer?: string;
    public hotelTransfer?: string;
    public noCabCharge?: number;
    public cabChargeSent?: boolean;
    public roomCompanion?: number;
    public roomCompanionName?: string;
    public roomCompanionDietaryRequirements?: string;
    public dietaryRequirement?: DietaryRequirementType;
    // @Ignore()
    public publicSection?: boolean;

    public isSpeaker?: boolean;
    public isBoard?: boolean;
    public guid?: string;
    public postalCountry?: string;
    public jobDescription?: string;
    public linkedInLink?: string;
    public twitterLink?: string;
    // @Ignore()
    public speakerBio?: File;

    // @Ignore()
    public speakerPhoto?: File;

    public checkInDate?: string;
    public checkOutDate?: string;
    public specialRequests?: string;
    public travelWithCompanion?: number;
    public cabCharge?: number;
    public cabChargeOption?: number;
    public companionFirstName?: string;
    public companionLastName?: string;
    public companionSharedAccommodation?: number;
    public companionCheckInDate?: string;
    public companionCheckOutDate?: string;
    public companionTwinBeds?: number;
    public companionAttendFacultyDinner?: number;
    public companionAttendConferenceDinner?: number;
    public companionDietaryRequirements?: string;
    public agreeSharePresentation?: number;
    public travelArrangementsNotRequired?: boolean;
    public accommodationArrangementsNotRequired?: boolean;
    public frequentFlyerNumberQantas?: string;
    public frequentFlyerNumberVirgin?: string;
    public frequentFlyerNumberAirNZ?: string;
    public frequentFlyerOther?: boolean;
    public frequentFlyerNameOther?: string;
    public frequentFlyerNumberOther?: string;
    public seatingPreference?: number;
    public checkedBaggage?: number;
    public departureDate?: string;
    public departureCity?: string;
    public desiredArrivalTime?: string;
    public returnDate?: string;
    public returnCity?: string;
    public desiredReturnTime?: string;
    public isTAndECSpeaker?: boolean;
    public speakerPresentations?: SpeakerPresentation[];
    public planeTickets?: PlaneTicket[];
    public yearlyAttendanceId?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;
    // @Ignore()
    public registrationType?: number;

    // @Ignore()
    public initialSpeakerEmail?: boolean;

    // @Ignore()
    public submittingSpeakerFromAdminSection?: boolean;

    // @Ignore()
    public submittingCustomRegistration?: boolean;

    // @Ignore()
    public addressSame?: boolean;

    public constructor(init?: Partial<Registration>) { (Object as any).assign(this, init); }
}

export class Sponsor implements IForm
{
    [immerable] = true;
    public id?: number;
    public repeat?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public sponsorName?: string;
    public sponsorLevel?: number;
    public freeRegistrations?: number;
    public registrationsUsed?: number;
    public emailExtension?: string;
    public additionalEmailExtensionOne?: string;
    public additionalEmailExtensionTwo?: string;
    public symposiums?: boolean;
    public sponsoredSymposiumId?: number;
    public sponsoredEarlyCareerId?: number;
    public traineeAndEarlyCareerDay?: boolean;
    public sponsoredGuestSpeaker?: boolean;
    public additionalFreeRegistrations?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<Sponsor>) { (Object as any).assign(this, init); }
}

export interface IUserGetSingle
{
    metadata?: { [index: string]: Object; };
}

export interface ILookupGetCollectionByFormDefinitionId extends IGet
{
    formDefinitionId?: number;
}

export interface IConfigurationGetSingleById extends IGet
{
    id?: number;
}

export interface IConfigurationGetCollection extends IGet
{
    skip?: number;
    take?: number;
}

export interface IConfigurationGetSingleByCode extends IGet
{
    code?: string;
}

export interface IDataGetSingleById extends IGet
{
    id?: number;
}

export interface IDataGetCollection extends IGet
{
    skip?: number;
    take?: number;
}

export enum SponsorableType
{
    Symposium = 1,
    EarlyCareerDay = 2,
}

export class Session implements IForm
{
    [immerable] = true;
    public repeat?: number;
    public id?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public name?: string;
    public description?: string;
    public sponsor?: string;
    public speaker?: string;
    public shortName?: string;
    public primarySession?: boolean;
    public startTime?: string;
    public endTime?: string;
    public location?: string;
    public setting?: string;
    public disabled?: boolean;
    public required?: boolean;
    public requiredGroup?: string;
    public requiredOr?: number[];
    public displayPublic?: boolean;
    public price?: number;
    public additionalPrice?: number;
    public additionalAttendees?: boolean;
    public additionalNotes?: boolean;
    public additionalNotesLabel?: string;
    public attendeeCap?: number;
    public restrictToMembers?: boolean;
    public restrictToTc?: boolean;
    public restrictToStudent?: boolean;
    public restrictToRegistrar?: boolean;
    public restrictToCap?: boolean;
    public disableForMembers?: boolean;
    public disableForTc?: boolean;
    public disableForStudent?: boolean;
    public disableForRegistrar?: boolean;
    public requiresPackage?: boolean;
    public inPersonOnly?: boolean;
    public eventType?: number;
    public sponsorableType?: SponsorableType;
    public sponsorId?: number;
    public disableForSponsor?: boolean;
    public rank?: number;
    public attendees?: number;
    public atCapacity?: boolean;
    public autoSetForSpeaker?: boolean;
    public showToSpeaker?: boolean;
    public showToTAndECSpeaker?: boolean;
    public autoSetForTAndECSpeaker?: boolean;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;
    public includeInCertificate?: boolean;
    public dateTimeOverride?: string;
    public attendeesAdministrationOnly?: boolean;
    public attendeesCancellationList?: boolean;
    public attendeesBeforeCapacityMessage?: string;
    public attendeesAfterCapacityMessage?: string;

    public constructor(init?: Partial<Session>) { (Object as any).assign(this, init); }
}

export class EarlyBirdRegistration implements IForm
{
    [immerable] = true;
    public id?: number;
    // @References("typeof(Conference.ServiceLogic.Models.Form.Registration)")
    public registrationId?: number;

    public invoiceSent?: boolean;
    public invoiceNumber?: string;
    public repeat?: number;
    public payments?: Payment[];
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;

    public constructor(init?: Partial<EarlyBirdRegistration>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    [immerable] = true;
    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ValidationErrorCodes
{
    [immerable] = true;
    public freeSponsorRegistrationsExhausted?: string;

    public constructor(init?: Partial<ValidationErrorCodes>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    [immerable] = true;
    // @DataMember(Order=1)
    public errorCode?: string;

    // @DataMember(Order=2)
    public fieldName?: string;

    // @DataMember(Order=3)
    public message?: string;

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable] = true;
    // @DataMember(Order=1)
    public errorCode?: string;

    // @DataMember(Order=2)
    public message?: string;

    // @DataMember(Order=3)
    public stackTrace?: string;

    // @DataMember(Order=4)
    public errors?: ResponseError[];

    // @DataMember(Order=5)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class BusinessCard
{
    [immerable] = true;
    public title?: string;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public specialty?: string;
    public institution?: string;

    public constructor(init?: Partial<BusinessCard>) { (Object as any).assign(this, init); }
}

export class EmailAddress
{
    [immerable] = true;
    public displayName?: string;
    public address?: string;

    public constructor(init?: Partial<EmailAddress>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    [immerable] = true;
    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

export class Package
{
    [immerable] = true;
    public id?: number;
    public name?: string;
    public description?: string;
    public memberPackage?: boolean;
    public sponsorPackage?: boolean;
    public specialRole?: boolean;
    public restrictToTc?: boolean;
    public restrictToStudent?: boolean;
    public restrictToRegistrar?: boolean;
    public online?: number;
    public price?: number;
    public discountPrice?: number;
    public availableToAll?: boolean;
    public showToSpeaker?: boolean;
    public sessions?: Session[];
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<Package>) { (Object as any).assign(this, init); }
}

export class InvoiceSession
{
    [immerable] = true;
    public name?: string;
    public description?: string;
    public includeInCertificate?: boolean;
    public includedInPackage?: boolean;
    public additionalAttendees?: number;
    public cost?: number;
    public additionalCost?: number;
    public registrationUpdateLink?: string;

    public constructor(init?: Partial<InvoiceSession>) { (Object as any).assign(this, init); }
}

export enum MembershipType
{
    Full = 1,
    Affiliate = 2,
    Life = 3,
}

export class PrintBadgeRegistrations
{
    [immerable] = true;
    public registrationId?: number;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public isPrinted?: boolean;
    public isFailed?: boolean;

    public constructor(init?: Partial<PrintBadgeRegistrations>) { (Object as any).assign(this, init); }
}

export class BadgePrintingData
{
    [immerable] = true;
    public id?: number;
    public fullName?: string;
    public adress?: string;
    public title?: string;
    public firstName?: string;
    public lastName?: string;
    public institution?: string;
    public speciality?: string;
    public qrCode?: string;
    public email?: string;
    public yearsAttended?: number;

    public constructor(init?: Partial<BadgePrintingData>) { (Object as any).assign(this, init); }
}

export class UserDto implements IUserDto
{
    [immerable] = true;
    public userId?: string;
    public userName?: string;
    public firstName?: string;
    public lastName?: string;
    public displayName?: string;
    public sessionId?: string;
    public isAdmin?: boolean;
    public hasRegistration?: boolean;
    public registration?: Registration;
    public registrationComplete?: boolean;

    public constructor(init?: Partial<UserDto>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    [immerable] = true;
    // @DataMember(Order=1)
    public key?: string;

    // @DataMember(Order=2)
    public keyType?: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface IFileUploadTemporary
{
    guid?: string;
    name?: string;
    extension?: string;
    fileSize?: number;
    contentType?: string;
    image?: boolean;
}

export class LookupItem
{
    [immerable] = true;
    public id?: number;
    public value?: string;
    public order?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    [immerable] = true;
    public propertyName?: string;
    public items?: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class FormMetadata
{
    [immerable] = true;
    public formDefinitionId?: number;
    public formDefinitionCode?: string;
    public name?: string;
    public propertyName?: string;
    public title?: string;
    public instructions?: string;

    public constructor(init?: Partial<FormMetadata>) { (Object as any).assign(this, init); }
}

export class FormType implements IFormType
{
    [immerable] = true;
    public id?: number;
    public code?: string;
    public name?: string;

    public constructor(init?: Partial<FormType>) { (Object as any).assign(this, init); }
}

export enum ValidationErrorType
{
    Warning = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5,
}

export class FormDefinitionPropertyErrorMessage implements IFormDefinitionPropertyErrorMessage
{
    [immerable] = true;
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Forms.Models.Configuration.FormDefinitionProperty)")
    public formDefinitionPropertyId?: number;

    public errorCode?: string;
    public message?: string;
    public detailedMessage?: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormDefinitionPropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormDefinitionProperty
{
    [immerable] = true;
    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Forms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public propertyName?: string;
    public label?: string;
    public detailedLabel?: string;
    public errorMessages?: FormDefinitionPropertyErrorMessage[];

    public constructor(init?: Partial<FormDefinitionProperty>) { (Object as any).assign(this, init); }
}

export class FormDefinition
{
    [immerable] = true;
    public id?: number;
    public code?: string;
    public type?: number;
    public name?: string;
    public instructions?: string;
    public patientInstructions?: string;
    public properties?: FormDefinitionProperty[];
    // @Ignore()
    public subformProperties?: { [index: string]: FormDefinitionProperty[]; };

    public constructor(init?: Partial<FormDefinition>) { (Object as any).assign(this, init); }
}

export enum ValidationResultType
{
    Valid = 1,
    Low = 2,
    Normal = 3,
    High = 4,
    Critical = 5,
}

export class ValidationError implements IValidationError
{
    [immerable] = true;
    public property?: string;
    public message?: string;
    public detailedMessage?: string;
    public code?: string;
    public ruleSet?: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<ValidationError>) { (Object as any).assign(this, init); }
}

export class ValidationResult
{
    [immerable] = true;
    public result?: ValidationResultType;
    public errors?: ValidationError[];
    public metadata?: { [index: string]: Object; };

    public constructor(init?: Partial<ValidationResult>) { (Object as any).assign(this, init); }
}

export interface IForm extends IDataModel, IHasParentFormDefinitionId, IHasParentFormId
{
    repeat?: number;
}

export interface IDataModel extends IModel, IHasAudit
{
}

export interface IModel
{
    id?: number;
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy?: string;
    modifiedDate?: string;
    modifiedBy?: string;
}

export interface IHasParentFormDefinitionId
{
    parentFormDefinitionId?: number;
}

export interface IHasParentFormId
{
    parentFormId?: number;
}

export interface IUserDto
{
    userId?: string;
    userName?: string;
    displayName?: string;
    sessionId?: string;
}

export interface ILookupItem
{
    id?: Object;
    value?: Object;
    order?: Object;
}

export interface ILookup
{
    propertyName?: string;
    items?: ILookupItem[];
}

export interface IFormType extends IConfigurationModel, IHasCode
{
    name?: string;
}

export interface IConfigurationModel extends IModel
{
}

export interface IHasCode
{
    code?: string;
}

export interface IFormDefinitionPropertyErrorMessage extends IConfigurationModel, IHasFormDefinitionPropertyId
{
    errorCode?: string;
    message?: string;
    detailedMessage?: string;
    type?: ValidationErrorType;
}

export interface IFormDefinitionProperty extends IConfigurationModel, IHasFormDefinitionId
{
    propertyName?: string;
    label?: string;
    detailedLabel?: string;
    errorMessages?: IFormDefinitionPropertyErrorMessage[];
}

export interface IFormDefinition extends IConfigurationModel, IHasCode
{
    type?: number;
    name?: string;
    instructions?: string;
    properties?: IFormDefinitionProperty[];
    subformProperties?: { [index: string]: IFormDefinitionProperty[]; };
}

export interface IValidationError
{
    property?: string;
    message?: string;
    detailedMessage?: string;
    code?: string;
    type?: ValidationErrorType;
}

export interface IValidationResult
{
    metadata?: { [index: string]: Object; };
    result?: ValidationResultType;
    errors?: IValidationError[];
}

export interface IFile extends IDataModel, IHasFormDefinitionId, IHasFormId, IFileUpload
{
    propertyName?: string;
}

export interface IHasFormDefinitionId
{
    formDefinitionId?: number;
}

export interface IHasFormId
{
    formId?: number;
}

export interface IFileUpload
{
    extension?: string;
    fileSize?: number;
    contentType?: string;
    exists?: boolean;
    image?: boolean;
    upload?: IFileUploadTemporary;
}

export interface IHasFormDefinitionPropertyId
{
    formDefinitionPropertyId?: number;
}

export class GetAppSettingsResponse
{
    [immerable] = true;
    public sentrySettings?: SentrySettings;
    public stripePublicKey?: string;
    public earlyBirdRegistrationEndDate?: string;
    public validationErrorCodes?: ValidationErrorCodes;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetBusinessCardDataByGuidResponse
{
    [immerable] = true;
    public businessCardData?: BusinessCard;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetBusinessCardDataByGuidResponse>) { (Object as any).assign(this, init); }
}

export class GetRegistrationsValidForCertificatesResponse
{
    [immerable] = true;
    public registrations?: Registration[];

    public constructor(init?: Partial<GetRegistrationsValidForCertificatesResponse>) { (Object as any).assign(this, init); }
}

export class ConferenceEmailResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public result?: string;
    public subject?: string;
    public toAddresses?: EmailAddress[];
    public ccAddresses?: EmailAddress[];
    public bccAddresses?: EmailAddress[];
    public fromAddress?: EmailAddress;

    public constructor(init?: Partial<ConferenceEmailResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    [immerable] = true;
    public settings?: ClientAppSettings;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetIsSacResponse
{
    [immerable] = true;
    public isSac?: boolean;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetIsSacResponse>) { (Object as any).assign(this, init); }
}

export class GetIsCapResponse
{
    [immerable] = true;
    public isCap?: boolean;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetIsCapResponse>) { (Object as any).assign(this, init); }
}

export class GetIsBoardResponse
{
    [immerable] = true;
    public isBoard?: boolean;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetIsBoardResponse>) { (Object as any).assign(this, init); }
}

export class GetEarlyBirdRegistrationPriceResponse
{
    [immerable] = true;
    public price?: number;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetEarlyBirdRegistrationPriceResponse>) { (Object as any).assign(this, init); }
}

export class GetEarlyBirdRegistrationsResponse
{
    [immerable] = true;
    public registrations?: Registration[];
    public count?: number;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetEarlyBirdRegistrationsResponse>) { (Object as any).assign(this, init); }
}

export class PostEarlyBirdRegistrationSaveResponse
{
    [immerable] = true;
    public registration?: EarlyBirdForm;
    public payment?: Payment;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PostEarlyBirdRegistrationSaveResponse>) { (Object as any).assign(this, init); }
}

export class GetAllEarlyBirdInformationByGuidResponse
{
    [immerable] = true;
    public earlyBirdRegistration?: EarlyBirdRegistration;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetAllEarlyBirdInformationByGuidResponse>) { (Object as any).assign(this, init); }
}

export class GeneratedEmailResponse
{
    [immerable] = true;
    public result?: string;

    public constructor(init?: Partial<GeneratedEmailResponse>) { (Object as any).assign(this, init); }
}

export class QueueInvoiceEmailResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<QueueInvoiceEmailResponse>) { (Object as any).assign(this, init); }
}

export class GetInvoiceDetailsByRegistrationIdResponse
{
    [immerable] = true;
    public title?: string;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public institution?: string;
    public address?: string;
    public suburb?: string;
    public state?: string;
    public postcode?: string;
    public country?: string;
    public member?: number;
    public paymentType?: string[];
    public dates?: string[];
    public package?: Package;
    public payments?: Payment[];
    public sessionDetails?: InvoiceSession[];
    public totalCost?: number;
    public subTotal?: number;
    public gst?: number;
    public totalPaid?: number;
    public customRegistration?: boolean;
    public freeRegistration?: boolean;
    public paidStatus?: string;
    public invoiceNumber?: string;
    public date?: string;
    public speciality?: number;
    public registrationUpdateLink?: string;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetInvoiceDetailsByRegistrationIdResponse>) { (Object as any).assign(this, init); }
}

export class GetEarlyBirdInvoiceByRegistrationIdResponse
{
    [immerable] = true;
    public title?: string;
    public firstName?: string;
    public lastName?: string;
    public email?: string;
    public institution?: string;
    public address?: string;
    public suburb?: string;
    public state?: string;
    public postcode?: string;
    public country?: string;
    public member?: number;
    public paymentType?: string[];
    public dates?: string[];
    public totalCost?: number;
    public subTotal?: number;
    public gst?: number;
    public totalPaid?: number;
    public payments?: Payment[];
    public paidStatus?: string;
    public invoiceNumber?: string;
    public date?: string;
    public speciality?: number;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetEarlyBirdInvoiceByRegistrationIdResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipStatusResponse
{
    [immerable] = true;
    public type?: MembershipType;
    public registered?: boolean;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetMembershipStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipTypeResponse
{
    [immerable] = true;
    public status?: MembershipType;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetMembershipTypeResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipDetailsResponse
{
    [immerable] = true;
    public title?: number;
    public firstName?: string;
    public lastName?: string;
    public address?: string;
    public suburb?: string;
    public postcode?: string;
    public state?: string;
    public country?: string;
    public phone?: string;
    public email?: string;
    public speciality?: number;
    public specialitySpec?: string;
    public institution?: string;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetMembershipDetailsResponse>) { (Object as any).assign(this, init); }
}

export class GetNumberYearsAttendedAsmResponse
{
    [immerable] = true;
    public yearlyAttendanceId?: number;
    public yearsAttended?: number;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetNumberYearsAttendedAsmResponse>) { (Object as any).assign(this, init); }
}

export class GetPackagesResponse
{
    [immerable] = true;
    public packages?: Package[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetPackagesResponse>) { (Object as any).assign(this, init); }
}

export class GetRegistrationPackagesResponse
{
    [immerable] = true;
    public packages?: Package[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetRegistrationPackagesResponse>) { (Object as any).assign(this, init); }
}

export class GetPackageByIdResponse
{
    [immerable] = true;
    public package?: Package;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetPackageByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPackageSessionsResponse
{
    [immerable] = true;
    public sessions?: Session[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetPackageSessionsResponse>) { (Object as any).assign(this, init); }
}

export class GetAdditionalPackageSessionsResponse
{
    [immerable] = true;
    public sessions?: Session[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetAdditionalPackageSessionsResponse>) { (Object as any).assign(this, init); }
}

export class GetIsStaffResponse
{
    [immerable] = true;
    public isStaff?: boolean;
    public registered?: boolean;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetIsStaffResponse>) { (Object as any).assign(this, init); }
}

export class SaveAsmBadgePrintResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public count?: number;
    public failedJobs?: number;

    public constructor(init?: Partial<SaveAsmBadgePrintResponse>) { (Object as any).assign(this, init); }
}

export class GetPrintBadgeRegistrationResponse
{
    [immerable] = true;
    public count?: number;
    public responseStatus?: ResponseStatus;
    public registrations?: PrintBadgeRegistrations[];

    public constructor(init?: Partial<GetPrintBadgeRegistrationResponse>) { (Object as any).assign(this, init); }
}

export class GetPrinterNamesResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public printers?: string[];

    public constructor(init?: Partial<GetPrinterNamesResponse>) { (Object as any).assign(this, init); }
}

export class PostLabelUploadAsyncResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PostLabelUploadAsyncResponse>) { (Object as any).assign(this, init); }
}

export class GetLabelFileUploadAsyncResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public fileContents?: string;
    public fileName?: string;

    public constructor(init?: Partial<GetLabelFileUploadAsyncResponse>) { (Object as any).assign(this, init); }
}

export class GetPrintBadgeRegistrationDetailsResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public badgeData?: BadgePrintingData[];

    public constructor(init?: Partial<GetPrintBadgeRegistrationDetailsResponse>) { (Object as any).assign(this, init); }
}

export class GetPrintSettingsResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public printingApi?: string;
    public bartenderCloudBaseApi?: string;

    public constructor(init?: Partial<GetPrintSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetRegistrationsResponse
{
    [immerable] = true;
    public registrations?: Registration[];
    public count?: number;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetRegistrationsResponse>) { (Object as any).assign(this, init); }
}

export class GetRegistrationsGivenSponsorResponse
{
    [immerable] = true;
    public registrations?: Registration[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetRegistrationsGivenSponsorResponse>) { (Object as any).assign(this, init); }
}

export class PostRegistrationPriceResponse
{
    [immerable] = true;
    public price?: number;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PostRegistrationPriceResponse>) { (Object as any).assign(this, init); }
}

export class DeleteRegistrationResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<DeleteRegistrationResponse>) { (Object as any).assign(this, init); }
}

export class ToggleRegistrationStatusResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ToggleRegistrationStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetRegisteredSessionsResponse
{
    [immerable] = true;
    public registrationSessions?: RegistrationSession[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetRegisteredSessionsResponse>) { (Object as any).assign(this, init); }
}

export class PostRegistrationSaveResponse
{
    [immerable] = true;
    public registration?: Registration;
    public payment?: Payment;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PostRegistrationSaveResponse>) { (Object as any).assign(this, init); }
}

export class GetNewReferenceNumberResponse
{
    [immerable] = true;
    public referenceNumber?: string;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetNewReferenceNumberResponse>) { (Object as any).assign(this, init); }
}

export class GetSessionsResponse
{
    [immerable] = true;
    public sessions?: Session[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetSessionsResponse>) { (Object as any).assign(this, init); }
}

export class GetSessionByIdResponse
{
    [immerable] = true;
    public session?: Session;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetSessionByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetSponsorSessionsResponse
{
    [immerable] = true;
    public sessions?: Session[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetSponsorSessionsResponse>) { (Object as any).assign(this, init); }
}

export class GetAllSpeakerInformationByGuidResponse
{
    [immerable] = true;
    public registration?: Registration;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetAllSpeakerInformationByGuidResponse>) { (Object as any).assign(this, init); }
}

export class GetAllSpeakerInformationByIdResponse
{
    [immerable] = true;
    public registration?: Registration;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetAllSpeakerInformationByIdResponse>) { (Object as any).assign(this, init); }
}

export class EmailSpeakerResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<EmailSpeakerResponse>) { (Object as any).assign(this, init); }
}

export class EmailSpeakerResendResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<EmailSpeakerResendResponse>) { (Object as any).assign(this, init); }
}

export class EmailCustomRegistrationResendResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<EmailCustomRegistrationResendResponse>) { (Object as any).assign(this, init); }
}

export class QueueEmailSpeakersToUpdateResendResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<QueueEmailSpeakersToUpdateResendResponse>) { (Object as any).assign(this, init); }
}

export class SaveSpeakerResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SaveSpeakerResponse>) { (Object as any).assign(this, init); }
}

export class GetSpeakersResponse
{
    [immerable] = true;
    public registration?: Registration[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetSpeakersResponse>) { (Object as any).assign(this, init); }
}

export class GetSponsorsResponse
{
    [immerable] = true;
    public sponsors?: Sponsor[];
    public count?: number;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetSponsorsResponse>) { (Object as any).assign(this, init); }
}

export class GetSponsorResponse
{
    [immerable] = true;
    public sponsor?: Sponsor;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetSponsorResponse>) { (Object as any).assign(this, init); }
}

export class DeleteSponsorResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<DeleteSponsorResponse>) { (Object as any).assign(this, init); }
}

export class PostSponsorSaveResponse
{
    [immerable] = true;
    public sponsor?: Sponsor;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PostSponsorSaveResponse>) { (Object as any).assign(this, init); }
}

export class GetCheckoutSessionResponse
{
    [immerable] = true;
    public clientSecret?: string;
    public clientReferenceId?: string;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetCheckoutSessionResponse>) { (Object as any).assign(this, init); }
}

export class GetPublicUserResponse
{
    [immerable] = true;
    public user?: UserDto;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetPublicUserResponse>) { (Object as any).assign(this, init); }
}

export class ClearPublicUserResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ClearPublicUserResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userId?: string;

    // @DataMember(Order=2)
    public sessionId?: string;

    // @DataMember(Order=3)
    public userName?: string;

    // @DataMember(Order=4)
    public displayName?: string;

    // @DataMember(Order=5)
    public referrerUrl?: string;

    // @DataMember(Order=6)
    public bearerToken?: string;

    // @DataMember(Order=7)
    public refreshToken?: string;

    // @DataMember(Order=8)
    public profileUrl?: string;

    // @DataMember(Order=9)
    public roles?: string[];

    // @DataMember(Order=10)
    public permissions?: string[];

    // @DataMember(Order=11)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=12)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public allRoles?: string[];

    // @DataMember(Order=2)
    public allPermissions?: string[];

    // @DataMember(Order=3)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public allRoles?: string[];

    // @DataMember(Order=2)
    public allPermissions?: string[];

    // @DataMember(Order=3)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public results?: UserApiKey[];

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    [immerable] = true;
    // @DataMember(Order=1)
    public results?: UserApiKey[];

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

export class UploadResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public upload?: IFileUploadTemporary;

    public constructor(init?: Partial<UploadResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved user. */
    // @DataMember(Order=2)
    public user?: UserDto;

    public constructor(init?: Partial<UserSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved lookups. */
    // @DataMember(Order=2)
    public lookups?: Lookup[];

    public constructor(init?: Partial<LookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormMetadataResponse
{
    [immerable] = true;
    public responseStatus?: ResponseStatus;
    public formMetadata?: FormMetadata[];

    public constructor(init?: Partial<GetFormMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormTypeSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form type. */
    // @DataMember(Order=2)
    public configuration?: FormType;

    public constructor(init?: Partial<FormTypeSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormTypeCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form types. */
    // @DataMember(Order=2)
    public configuration?: FormType[];

    public constructor(init?: Partial<FormTypeCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form definition. */
    // @DataMember(Order=2)
    public configuration?: FormDefinition;

    public constructor(init?: Partial<FormDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form definitions. */
    // @DataMember(Order=2)
    public configuration?: FormDefinition[];

    public constructor(init?: Partial<FormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EarlyBirdFormSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved early bird form. */
    // @DataMember(Order=2)
    public data?: EarlyBirdForm;

    public constructor(init?: Partial<EarlyBirdFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EarlyBirdFormCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved early bird forms. */
    // @DataMember(Order=2)
    public data?: EarlyBirdForm[];

    public constructor(init?: Partial<EarlyBirdFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EarlyBirdFormValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<EarlyBirdFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved registration. */
    // @DataMember(Order=2)
    public data?: Registration;

    public constructor(init?: Partial<RegistrationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved registrations. */
    // @DataMember(Order=2)
    public data?: Registration[];

    public constructor(init?: Partial<RegistrationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<RegistrationValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SessionSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved session. */
    // @DataMember(Order=2)
    public data?: Session;

    public constructor(init?: Partial<SessionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SessionCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved sessions. */
    // @DataMember(Order=2)
    public data?: Session[];

    public constructor(init?: Partial<SessionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SessionValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<SessionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SponsorSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved sponsor. */
    // @DataMember(Order=2)
    public data?: Sponsor;

    public constructor(init?: Partial<SponsorSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SponsorCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved sponsors. */
    // @DataMember(Order=2)
    public data?: Sponsor[];

    public constructor(init?: Partial<SponsorCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SponsorValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<SponsorValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PlaneTicketSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved plane ticket. */
    // @DataMember(Order=2)
    public data?: PlaneTicket;

    public constructor(init?: Partial<PlaneTicketSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PlaneTicketCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved plane tickets. */
    // @DataMember(Order=2)
    public data?: PlaneTicket[];

    public constructor(init?: Partial<PlaneTicketCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PlaneTicketValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<PlaneTicketValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SpeakerPresentationSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved speaker presentation. */
    // @DataMember(Order=2)
    public data?: SpeakerPresentation;

    public constructor(init?: Partial<SpeakerPresentationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SpeakerPresentationCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved speaker presentations. */
    // @DataMember(Order=2)
    public data?: SpeakerPresentation[];

    public constructor(init?: Partial<SpeakerPresentationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SpeakerPresentationValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<SpeakerPresentationValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EarlyBirdRegistrationSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved early bird registration. */
    // @DataMember(Order=2)
    public data?: EarlyBirdRegistration;

    public constructor(init?: Partial<EarlyBirdRegistrationSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EarlyBirdRegistrationCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved early bird registrations. */
    // @DataMember(Order=2)
    public data?: EarlyBirdRegistration[];

    public constructor(init?: Partial<EarlyBirdRegistrationCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EarlyBirdRegistrationValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<EarlyBirdRegistrationValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PaymentSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved payment. */
    // @DataMember(Order=2)
    public data?: Payment;

    public constructor(init?: Partial<PaymentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PaymentCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved payments. */
    // @DataMember(Order=2)
    public data?: Payment[];

    public constructor(init?: Partial<PaymentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PaymentValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<PaymentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationCancellationListSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved registration cancellation list. */
    // @DataMember(Order=2)
    public data?: RegistrationCancellationList;

    public constructor(init?: Partial<RegistrationCancellationListSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationCancellationListCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved registration cancellation lists. */
    // @DataMember(Order=2)
    public data?: RegistrationCancellationList[];

    public constructor(init?: Partial<RegistrationCancellationListCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationCancellationListValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<RegistrationCancellationListValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationSessionSingleResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved registration session. */
    // @DataMember(Order=2)
    public data?: RegistrationSession;

    public constructor(init?: Partial<RegistrationSessionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationSessionCollectionResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved registration sessions. */
    // @DataMember(Order=2)
    public data?: RegistrationSession[];

    public constructor(init?: Partial<RegistrationSessionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationSessionValidationResponse
{
    [immerable] = true;
    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: ValidationResult;

    public constructor(init?: Partial<RegistrationSessionValidationResponse>) { (Object as any).assign(this, init); }
}

export class GetAppSettings implements IReturn<GetAppSettingsResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAppSettingsResponse(); }
}

// @Route("/card/data/{Guid}", "GET")
export class GetBusinessCardDataByGuid implements IReturn<GetBusinessCardDataByGuidResponse>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetBusinessCardDataByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessCardDataByGuid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBusinessCardDataByGuidResponse(); }
}

// @Route("/card/export/{Guid}", "GET")
export class ExportContactDetailsVCF implements IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<ExportContactDetailsVCF>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportContactDetailsVCF'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class CreateCertificate implements IReturn<Blob>
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<CreateCertificate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCertificate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

export class GetRegistrationsValidForCertificates implements IReturn<GetRegistrationsValidForCertificatesResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetRegistrationsValidForCertificates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRegistrationsValidForCertificates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRegistrationsValidForCertificatesResponse(); }
}

export class QueueCertificates
{
    [immerable] = true;
    public registrationIds?: number[];

    public constructor(init?: Partial<QueueCertificates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueCertificates'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

export class QueueCertificate implements IReturnVoid
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<QueueCertificate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueCertificate'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

export class SendCertificate extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<SendCertificate>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendCertificate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

// @Route("/conference/is-sac", "GET")
export class GetIsSac implements IReturn<GetIsSacResponse>, IGet
{
    [immerable] = true;
    /** @description The FirstName */
    // @ApiMember(Description="The FirstName", IsRequired=true, Name="FirstName", ParameterType="query")
    public firstName?: string;

    /** @description The LastName */
    // @ApiMember(Description="The LastName", IsRequired=true, Name="LastName", ParameterType="query")
    public lastName?: string;

    public constructor(init?: Partial<GetIsSac>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetIsSac'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetIsSacResponse(); }
}

// @Route("/conference/is-cap", "GET")
export class GetIsCap implements IReturn<GetIsCapResponse>, IGet
{
    [immerable] = true;
    /** @description The FirstName */
    // @ApiMember(Description="The FirstName", IsRequired=true, Name="FirstName", ParameterType="query")
    public firstName?: string;

    /** @description The LastName */
    // @ApiMember(Description="The LastName", IsRequired=true, Name="LastName", ParameterType="query")
    public lastName?: string;

    public constructor(init?: Partial<GetIsCap>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetIsCap'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetIsCapResponse(); }
}

// @Route("/conference/is-board", "GET")
export class GetIsBoard implements IReturn<GetIsBoardResponse>, IGet
{
    [immerable] = true;
    /** @description The FirstName */
    // @ApiMember(Description="The FirstName", IsRequired=true, Name="FirstName", ParameterType="query")
    public firstName?: string;

    /** @description The LastName */
    // @ApiMember(Description="The LastName", IsRequired=true, Name="LastName", ParameterType="query")
    public lastName?: string;

    public constructor(init?: Partial<GetIsBoard>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetIsBoard'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetIsBoardResponse(); }
}

// @Route("/early-bird-price", "GET")
export class GetEarlyBirdRegistrationPrice implements IReturn<GetEarlyBirdRegistrationPriceResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetEarlyBirdRegistrationPrice>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEarlyBirdRegistrationPrice'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEarlyBirdRegistrationPriceResponse(); }
}

// @Route("/report/early-bird-export", "GET")
export class GetExportEarlyBirdRegistrations implements IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetExportEarlyBirdRegistrations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetExportEarlyBirdRegistrations'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/early-bird/registrations", "GET")
export class GetEarlyBirdRegistrations implements IReturn<GetEarlyBirdRegistrationsResponse>, IGet
{
    [immerable] = true;
    public sort?: RegistrationSort;
    public descending?: boolean;
    public page?: number;
    public rows?: number;
    public includeExpired?: boolean;
    public includeSessions?: boolean;
    public includeDeleted?: boolean;
    public search?: string;
    public registrationStatus?: RegistrationStatus;

    public constructor(init?: Partial<GetEarlyBirdRegistrations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEarlyBirdRegistrations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEarlyBirdRegistrationsResponse(); }
}

export class PostEarlyBirdRegistrationSave implements IReturn<PostEarlyBirdRegistrationSaveResponse>, IPost
{
    [immerable] = true;
    public earlyBirdForm?: EarlyBirdForm;

    public constructor(init?: Partial<PostEarlyBirdRegistrationSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostEarlyBirdRegistrationSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostEarlyBirdRegistrationSaveResponse(); }
}

export class GetAllEarlyBirdInformationByGuid implements IReturn<GetAllEarlyBirdInformationByGuidResponse>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetAllEarlyBirdInformationByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllEarlyBirdInformationByGuid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAllEarlyBirdInformationByGuidResponse(); }
}

export class GenerateInvoiceEmail implements IReturn<GeneratedEmailResponse>, IGet
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<GenerateInvoiceEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GenerateInvoiceEmail'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneratedEmailResponse(); }
}

export class GenerateEarlyBirdInvoiceEmail implements IReturn<GeneratedEmailResponse>, IGet
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<GenerateEarlyBirdInvoiceEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GenerateEarlyBirdInvoiceEmail'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneratedEmailResponse(); }
}

export class SendInvoiceEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<SendInvoiceEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendInvoiceEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class SendSpeakerEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;
    public link?: string;
    public email?: string;

    public constructor(init?: Partial<SendSpeakerEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSpeakerEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class SendCustomRegistrationEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;
    public link?: string;
    public email?: string;

    public constructor(init?: Partial<SendCustomRegistrationEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendCustomRegistrationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class SendSpeakerReminderEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;
    public link?: string;
    public email?: string;

    public constructor(init?: Partial<SendSpeakerReminderEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSpeakerReminderEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class SendCustomRegistrationReminderEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;
    public link?: string;
    public email?: string;

    public constructor(init?: Partial<SendCustomRegistrationReminderEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendCustomRegistrationReminderEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class SendSpeakerPleaseUpdateEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;
    public link?: string;
    public email?: string;

    public constructor(init?: Partial<SendSpeakerPleaseUpdateEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSpeakerPleaseUpdateEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class SendChangedTravelDetailsEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public invoiceNumber?: string;
    public firstName?: string;
    public lastName?: string;
    public checkInDate?: string;
    public checkOutDate?: string;
    public specialRequests?: string;
    public travelWithCompanion?: number;
    public companionFirstName?: string;
    public companionLastName?: string;
    public companionSharedAccommodation?: number;
    public companionCheckInDate?: string;
    public companionCheckOutDate?: string;
    public companionTwinBeds?: number;
    public companionAttendFacultyDinner?: number;
    public companionAttendConferenceDinner?: number;
    public companionDietaryRequirements?: string;
    public agreeSharePresentation?: number;
    public frequentFlyerNumberQantas?: string;
    public frequentFlyerNumberVirgin?: string;
    public frequentFlyerNumberAirNZ?: string;
    public frequentFlyerOther?: boolean;
    public frequentFlyerNameOther?: string;
    public frequentFlyerNumberOther?: string;
    public seatingPreference?: number;
    public checkedBaggage?: number;
    public departureDate?: string;
    public departureCity?: string;
    public desiredArrivalTime?: string;
    public returnDate?: string;
    public returnCity?: string;
    public desiredReturnTime?: string;
    public cabCharge?: number;
    public cabChargeOption?: number;
    public cabChargeSent?: boolean;

    public constructor(init?: Partial<SendChangedTravelDetailsEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendChangedTravelDetailsEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class SendSpeakerUploadedDetailsEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;
    public biographyUploaded?: boolean;
    public pictureUploaded?: boolean;
    public slidesUploaded?: boolean;
    public travelInformationUploaded?: boolean;

    public constructor(init?: Partial<SendSpeakerUploadedDetailsEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSpeakerUploadedDetailsEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

export class SendEarlyBirdInvoiceEmail extends ConferenceEmail implements IReturn<ConferenceEmailResponse>, IPost
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<SendEarlyBirdInvoiceEmail>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEarlyBirdInvoiceEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConferenceEmailResponse(); }
}

// @Route("/conference/queue-invoice/{RegistrationId}", "GET")
export class QueueInvoiceEmail implements IReturn<QueueInvoiceEmailResponse>, IGet
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<QueueInvoiceEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueInvoiceEmail'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueueInvoiceEmailResponse(); }
}

// @Route("/conference/invoice-details", "GET")
export class GetInvoiceDetailsByRegistrationId implements IReturn<GetInvoiceDetailsByRegistrationIdResponse>, IGet
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<GetInvoiceDetailsByRegistrationId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceDetailsByRegistrationId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvoiceDetailsByRegistrationIdResponse(); }
}

// @Route("/conference/invoice-details", "GET")
export class GetEarlyBirdInvoiceByRegistrationId implements IReturn<GetEarlyBirdInvoiceByRegistrationIdResponse>, IGet
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<GetEarlyBirdInvoiceByRegistrationId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEarlyBirdInvoiceByRegistrationId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEarlyBirdInvoiceByRegistrationIdResponse(); }
}

// @Route("/conference/membership-status", "GET")
export class GetMembershipStatus implements IReturn<GetMembershipStatusResponse>, IGet
{
    [immerable] = true;
    /** @description The FirstName */
    // @ApiMember(Description="The FirstName", IsRequired=true, Name="FirstName", ParameterType="query")
    public firstName?: string;

    /** @description The FirstName */
    // @ApiMember(Description="The FirstName", IsRequired=true, Name="FirstName", ParameterType="query")
    public lastName?: string;

    public constructor(init?: Partial<GetMembershipStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMembershipStatus'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMembershipStatusResponse(); }
}

export class GetMembershipType implements IReturn<GetMembershipTypeResponse>, IGet
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;

    public constructor(init?: Partial<GetMembershipType>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMembershipType'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMembershipTypeResponse(); }
}

export class GetMembershipDetails implements IReturn<GetMembershipDetailsResponse>, IGet
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;

    public constructor(init?: Partial<GetMembershipDetails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMembershipDetails'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMembershipDetailsResponse(); }
}

// @Route("/conference/asm-attended", "GET")
export class GetNumberYearsAttendedAsm implements IReturn<GetNumberYearsAttendedAsmResponse>, IGet
{
    [immerable] = true;
    public firstName?: string;
    public lastName?: string;

    public constructor(init?: Partial<GetNumberYearsAttendedAsm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNumberYearsAttendedAsm'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNumberYearsAttendedAsmResponse(); }
}

export class GetPackages implements IReturn<GetPackagesResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetPackages>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPackages'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPackagesResponse(); }
}

export class GetRegistrationPackages implements IReturn<GetRegistrationPackagesResponse>, IGet
{
    [immerable] = true;
    public member?: number;
    public restrictToTc?: boolean;
    public restrictToStudent?: boolean;
    public restrictToRegistrar?: boolean;
    public staff?: boolean;
    public attendeeFromJapanOrKorea?: boolean;
    public sponsor?: boolean;
    public freeSponsorRegistration?: boolean;
    public isSac?: boolean;
    public isCap?: boolean;
    public isSpeaker?: boolean;

    public constructor(init?: Partial<GetRegistrationPackages>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRegistrationPackages'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRegistrationPackagesResponse(); }
}

export class GetPackageById implements IReturn<GetPackageByIdResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetPackageById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPackageById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPackageByIdResponse(); }
}

export class GetPackageSessions implements IReturn<GetPackageSessionsResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetPackageSessions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPackageSessions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPackageSessionsResponse(); }
}

export class GetAdditionalPackageSessions implements IReturn<GetAdditionalPackageSessionsResponse>, IGet
{
    [immerable] = true;
    public id?: number;
    public isAdminSection?: boolean;
    public isSpeaker?: boolean;
    public isTAndECSpeaker?: boolean;

    public constructor(init?: Partial<GetAdditionalPackageSessions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAdditionalPackageSessions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAdditionalPackageSessionsResponse(); }
}

// @Route("/conference/is-staff", "GET")
export class GetIsStaff implements IReturn<GetIsStaffResponse>, IGet
{
    [immerable] = true;
    /** @description The FirstName */
    // @ApiMember(Description="The FirstName", IsRequired=true, Name="FirstName", ParameterType="query")
    public firstName?: string;

    /** @description The LastName */
    // @ApiMember(Description="The LastName", IsRequired=true, Name="LastName", ParameterType="query")
    public lastName?: string;

    public constructor(init?: Partial<GetIsStaff>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetIsStaff'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetIsStaffResponse(); }
}

export class SaveAsmBadgePrint implements IReturn<SaveAsmBadgePrintResponse>, IPost
{
    [immerable] = true;
    public printJobs?: SavePrintJob[];

    public constructor(init?: Partial<SaveAsmBadgePrint>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveAsmBadgePrint'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaveAsmBadgePrintResponse(); }
}

// @Route("/print/registrations", "GET")
export class GetPrintBadgeRegistration implements IReturn<GetPrintBadgeRegistrationResponse>, IGet
{
    [immerable] = true;
    public page?: number;
    public rows?: number;
    public search?: string;

    public constructor(init?: Partial<GetPrintBadgeRegistration>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPrintBadgeRegistration'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPrintBadgeRegistrationResponse(); }
}

// @Route("/print/get-printer-names", "GET")
export class GetPrinterNames implements IReturn<GetPrinterNamesResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetPrinterNames>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPrinterNames'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPrinterNamesResponse(); }
}

export class PostLabelUploadAsync implements IReturn<PostLabelUploadAsyncResponse>, IPost
{
    [immerable] = true;
    public file?: IFormFile;

    public constructor(init?: Partial<PostLabelUploadAsync>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostLabelUploadAsync'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostLabelUploadAsyncResponse(); }
}

export class GetLabelFileUploadAsync implements IReturn<GetLabelFileUploadAsyncResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetLabelFileUploadAsync>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLabelFileUploadAsync'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLabelFileUploadAsyncResponse(); }
}

export class GetPrintBadgeRegistrationDetails implements IReturn<GetPrintBadgeRegistrationDetailsResponse>, IPost
{
    [immerable] = true;
    public registrationId?: number[];
    public printSettings?: AsmPrintSettings;

    public constructor(init?: Partial<GetPrintBadgeRegistrationDetails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPrintBadgeRegistrationDetails'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetPrintBadgeRegistrationDetailsResponse(); }
}

export class GetPrintSettings implements IReturn<GetPrintSettingsResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetPrintSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPrintSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPrintSettingsResponse(); }
}

export class GetRegistrations implements IReturn<GetRegistrationsResponse>, IGet
{
    [immerable] = true;
    public sort?: RegistrationSort;
    public descending?: boolean;
    public page?: number;
    public rows?: number;
    public includeExpired?: boolean;
    public includeSessions?: boolean;
    public includeDeleted?: boolean;
    public search?: string;
    public registrationStatus?: RegistrationStatus;

    public constructor(init?: Partial<GetRegistrations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRegistrations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRegistrationsResponse(); }
}

export class GetRegistrationsGivenSponsor implements IReturn<GetRegistrationsGivenSponsorResponse>, IGet
{
    [immerable] = true;
    public sponsorId?: number;

    public constructor(init?: Partial<GetRegistrationsGivenSponsor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRegistrationsGivenSponsor'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRegistrationsGivenSponsorResponse(); }
}

export class PostRegistrationPrice implements IReturn<PostRegistrationPriceResponse>, IPost
{
    [immerable] = true;
    public registration?: Registration;

    public constructor(init?: Partial<PostRegistrationPrice>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostRegistrationPrice'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostRegistrationPriceResponse(); }
}

export class DeleteRegistration implements IReturn<DeleteRegistrationResponse>, IDelete
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<DeleteRegistration>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteRegistration'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteRegistrationResponse(); }
}

export class ToggleRegistrationStatus implements IReturn<ToggleRegistrationStatusResponse>, IPatch
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<ToggleRegistrationStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ToggleRegistrationStatus'; }
    public getMethod() { return 'PATCH'; }
    public createResponse() { return new ToggleRegistrationStatusResponse(); }
}

export class GetRegisteredSessions implements IReturn<GetRegisteredSessionsResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetRegisteredSessions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRegisteredSessions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRegisteredSessionsResponse(); }
}

export class PostRegistrationSave implements IReturn<PostRegistrationSaveResponse>, IPost
{
    [immerable] = true;
    public registration?: Registration;

    public constructor(init?: Partial<PostRegistrationSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostRegistrationSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostRegistrationSaveResponse(); }
}

export class GetNewReferenceNumber implements IReturn<GetNewReferenceNumberResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetNewReferenceNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNewReferenceNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetNewReferenceNumberResponse(); }
}

// @Route("/report/where-did-you-hear/{Year}", "GET")
export class ExportWhereDidYouHearReport implements IGet
{
    [immerable] = true;
    public year?: number;

    public constructor(init?: Partial<ExportWhereDidYouHearReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportWhereDidYouHearReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/report/delegate/{Year}", "GET")
export class ExportDelegateReport implements IGet
{
    [immerable] = true;
    public year?: number;

    public constructor(init?: Partial<ExportDelegateReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportDelegateReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/report/registration/{Year}", "GET")
export class ExportRegistrationReport implements IGet
{
    [immerable] = true;
    public year?: number;

    public constructor(init?: Partial<ExportRegistrationReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportRegistrationReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/report/outstandingPayment/{Year}", "GET")
export class ExportOutstandingPaymentReport implements IGet
{
    [immerable] = true;
    public year?: number;

    public constructor(init?: Partial<ExportOutstandingPaymentReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportOutstandingPaymentReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/report/attendance/{Year}", "GET")
export class ExportAttendanceReport implements IGet
{
    [immerable] = true;
    public year?: number;

    public constructor(init?: Partial<ExportAttendanceReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportAttendanceReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/report/additional-credit-card/{Year}", "GET")
export class ExportAdditionalCreditCardReport implements IGet
{
    [immerable] = true;
    public year?: number;

    public constructor(init?: Partial<ExportAdditionalCreditCardReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportAdditionalCreditCardReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/report/attendee-payment/{Year}", "GET")
export class ExportAttendeePaymentReport implements IGet
{
    [immerable] = true;
    public year?: number;

    public constructor(init?: Partial<ExportAttendeePaymentReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportAttendeePaymentReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/report/session/{Year}/{SessionId}", "GET")
export class ExportSessionReport implements IGet
{
    [immerable] = true;
    public year?: number;
    public sessionId?: number;

    public constructor(init?: Partial<ExportSessionReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportSessionReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/report/cancellation-list/{Year}", "GET")
export class exportSessionCancellationListReport implements IGet
{
    [immerable] = true;
    public year?: number;

    public constructor(init?: Partial<exportSessionCancellationListReport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'exportSessionCancellationListReport'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class GetSessions implements IReturn<GetSessionsResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetSessions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSessions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSessionsResponse(); }
}

export class GetSessionById implements IReturn<GetSessionByIdResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetSessionById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSessionById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSessionByIdResponse(); }
}

export class GetSponsorSessions implements IReturn<GetSponsorSessionsResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetSponsorSessions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSponsorSessions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSponsorSessionsResponse(); }
}

export class GetAllSpeakerInformationByGuid implements IReturn<GetAllSpeakerInformationByGuidResponse>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetAllSpeakerInformationByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllSpeakerInformationByGuid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAllSpeakerInformationByGuidResponse(); }
}

export class GetAllSpeakerInformationById implements IReturn<GetAllSpeakerInformationByIdResponse>, IGet
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<GetAllSpeakerInformationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllSpeakerInformationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAllSpeakerInformationByIdResponse(); }
}

export class EmailSpeaker implements IReturn<EmailSpeakerResponse>, IGet
{
    [immerable] = true;
    public registration?: Registration;

    public constructor(init?: Partial<EmailSpeaker>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmailSpeaker'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EmailSpeakerResponse(); }
}

export class EmailSpeakerResend implements IReturn<EmailSpeakerResendResponse>, IGet
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<EmailSpeakerResend>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmailSpeakerResend'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EmailSpeakerResendResponse(); }
}

export class EmailCustomRegistrationResend implements IReturn<EmailCustomRegistrationResendResponse>, IGet
{
    [immerable] = true;
    public registrationId?: number;

    public constructor(init?: Partial<EmailCustomRegistrationResend>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmailCustomRegistrationResend'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EmailCustomRegistrationResendResponse(); }
}

export class QueueEmailSpeakersToUpdateResend implements IReturn<QueueEmailSpeakersToUpdateResendResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<QueueEmailSpeakersToUpdateResend>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueEmailSpeakersToUpdateResend'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueueEmailSpeakersToUpdateResendResponse(); }
}

export class SaveSpeaker implements IReturn<SaveSpeakerResponse>, IGet
{
    [immerable] = true;
    public registration?: Registration;

    public constructor(init?: Partial<SaveSpeaker>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveSpeaker'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaveSpeakerResponse(); }
}

export class GetSpeakers implements IReturn<GetSpeakersResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetSpeakers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSpeakers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSpeakersResponse(); }
}

// @Route("/download/asm-template", "GET")
export class DownloadASM implements IGet
{
    [immerable] = true;

    public constructor(init?: Partial<DownloadASM>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadASM'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class GetSponsors implements IReturn<GetSponsorsResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetSponsors>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSponsors'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSponsorsResponse(); }
}

export class GetSponsor implements IReturn<GetSponsorResponse>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetSponsor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSponsor'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSponsorResponse(); }
}

export class DeleteSponsor implements IReturn<DeleteSponsorResponse>, IDelete
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<DeleteSponsor>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteSponsor'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteSponsorResponse(); }
}

export class PostSponsorSave implements IReturn<PostSponsorSaveResponse>, IPost
{
    [immerable] = true;
    public sponsor?: Sponsor;

    public constructor(init?: Partial<PostSponsorSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSponsorSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSponsorSaveResponse(); }
}

export class GetCheckoutSession implements IReturn<GetCheckoutSessionResponse>, IGet
{
    [immerable] = true;
    public amount?: number;
    public email?: string;

    public constructor(init?: Partial<GetCheckoutSession>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCheckoutSession'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCheckoutSessionResponse(); }
}

// @Route("/conference/user", "GET")
export class GetPublicUser implements IReturn<GetPublicUserResponse>, IGet
{
    [immerable] = true;

    public constructor(init?: Partial<GetPublicUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPublicUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPublicUserResponse(); }
}

// @Route("/conference/user-clear", "POST")
export class ClearPublicUser implements IReturn<ClearPublicUserResponse>, IPost
{
    [immerable] = true;

    public constructor(init?: Partial<ClearPublicUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearPublicUser'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ClearPublicUserResponse(); }
}

/** @description Sign In */
// @Route("/auth", "OPTIONS,GET,POST,DELETE")
// @Route("/auth/{provider}", "OPTIONS,GET,POST,DELETE")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable] = true;
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider?: string;

    // @DataMember(Order=2)
    public state?: string;

    // @DataMember(Order=3)
    public oauth_token?: string;

    // @DataMember(Order=4)
    public oauth_verifier?: string;

    // @DataMember(Order=5)
    public userName?: string;

    // @DataMember(Order=6)
    public password?: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView?: string;

    // @DataMember(Order=10)
    public nonce?: string;

    // @DataMember(Order=11)
    public uri?: string;

    // @DataMember(Order=12)
    public response?: string;

    // @DataMember(Order=13)
    public qop?: string;

    // @DataMember(Order=14)
    public nc?: string;

    // @DataMember(Order=15)
    public cnonce?: string;

    // @DataMember(Order=17)
    public accessToken?: string;

    // @DataMember(Order=18)
    public accessTokenSecret?: string;

    // @DataMember(Order=19)
    public scope?: string;

    // @DataMember(Order=20)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userName?: string;

    // @DataMember(Order=2)
    public permissions?: string[];

    // @DataMember(Order=3)
    public roles?: string[];

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public userName?: string;

    // @DataMember(Order=2)
    public permissions?: string[];

    // @DataMember(Order=3)
    public roles?: string[];

    // @DataMember(Order=4)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    [immerable] = true;
    // @DataMember(Order=1)
    public environment?: string;

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    [immerable] = true;
    // @DataMember(Order=1)
    public environment?: string;

    // @DataMember(Order=2)
    public meta?: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

// @Route("/conference/file-upload", "POST")
export class PostUploadFile implements IReturn<UploadResponse>, IPost
{
    [immerable] = true;

    public constructor(init?: Partial<PostUploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/conference/file-upload/info/{Guid}", "GET")
export class GetUploadInfo implements IReturn<UploadResponse>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetUploadInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/conference/file-upload/{Guid}", "GET")
export class GetUpload implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<GetUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/conference/file-upload/download/{Guid}", "GET")
export class DownloadUpload implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<DownloadUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/conference/file-upload/{Guid}", "DELETE")
export class DeleteUpload implements IReturn<UploadResponse>, IDelete
{
    [immerable] = true;
    public guid?: string;

    public constructor(init?: Partial<DeleteUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUpload'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/conference/user/single/user", "GET")
// @Api(Description="User - UserDto")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.User.UserSingleResponse)", StatusCode=500)
// @DataContract
export class UserGetSingle implements IReturn<UserSingleResponse>, IUserGetSingle
{
    [immerable] = true;
    /** @description The metadata of the request. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    public constructor(init?: Partial<UserGetSingle>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserGetSingle'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserSingleResponse(); }
}

// @Route("/conference/lookup/collection/form-definition/{FormDefinitionId}", "GET")
// @Api(Description="Lookup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Lookup.LookupCollectionResponse)", StatusCode=500)
// @DataContract
export class LookupGetCollectionByFormDefinitionId implements IReturn<LookupCollectionResponse>, ILookupGetCollectionByFormDefinitionId
{
    [immerable] = true;
    /** @description The ID of the Form Definition associated with the lookup to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId?: number;

    public constructor(init?: Partial<LookupGetCollectionByFormDefinitionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupGetCollectionByFormDefinitionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LookupCollectionResponse(); }
}

// @Route("/conference/form-names", "GET")
export class GetFormMetadata implements IReturn<GetFormMetadataResponse>
{
    [immerable] = true;

    public constructor(init?: Partial<GetFormMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormMetadataResponse(); }
}

// @Route("/conference/form-type/single/id/{Id}", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetSingleById implements IReturn<FormTypeSingleResponse>, IConfigurationGetSingleById
{
    [immerable] = true;
    /** @description The ID of the form type to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormTypeGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeSingleResponse(); }
}

// @Route("/conference/form-type/collection", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeCollectionResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetCollection implements IReturn<FormTypeCollectionResponse>, IConfigurationGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<FormTypeGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeCollectionResponse(); }
}

// @Route("/conference/form-type/single/code/{Code}", "GET")
// @Api(Description="Form Type")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormType.FormTypeSingleResponse)", StatusCode=500)
// @DataContract
export class FormTypeGetSingleByCode implements IReturn<FormTypeSingleResponse>, IConfigurationGetSingleByCode
{
    [immerable] = true;
    /** @description The ID of the form type to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<FormTypeGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTypeGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormTypeSingleResponse(); }
}

// @Route("/conference/form-definition/single/id/{Id}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleById implements IReturn<FormDefinitionSingleResponse>, IConfigurationGetSingleById
{
    [immerable] = true;
    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/conference/form-definition/collection", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetCollection implements IReturn<FormDefinitionCollectionResponse>, IConfigurationGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<FormDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionCollectionResponse(); }
}

// @Route("/conference/form-definition/single/code/{Code}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleByCode implements IReturn<FormDefinitionSingleResponse>, IConfigurationGetSingleByCode
{
    [immerable] = true;
    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<FormDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/conference/form/early-bird-form/single/id/{Id}", "GET")
// @Api(Description="Form - EarlyBirdForm")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdFormGetSingleById implements IReturn<EarlyBirdFormSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the early bird form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EarlyBirdFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EarlyBirdFormSingleResponse(); }
}

// @Route("/conference/form/early-bird-form/collection", "GET")
// @Api(Description="Form - EarlyBirdForm")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdFormCollectionResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdFormGetCollection implements IReturn<EarlyBirdFormCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<EarlyBirdFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EarlyBirdFormCollectionResponse(); }
}

// @Route("/conference/form/early-bird-form/create", "POST")
// @Api(Description="Form - EarlyBirdForm")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdFormPostCreate implements IReturn<EarlyBirdFormSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the early bird form. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the early bird form. */
    // @DataMember(Order=2)
    public data?: EarlyBirdForm;

    public constructor(init?: Partial<EarlyBirdFormPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdFormPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EarlyBirdFormSingleResponse(); }
}

// @Route("/conference/form/early-bird-form/save", "POST")
// @Api(Description="Form - EarlyBirdForm")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdFormSingleResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdFormPostSave implements IReturn<EarlyBirdFormSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the early bird form. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The early bird form to save. */
    // @DataMember(Order=2)
    public data?: EarlyBirdForm;

    public constructor(init?: Partial<EarlyBirdFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EarlyBirdFormSingleResponse(); }
}

// @Route("/conference/form/early-bird-form/validate", "POST")
// @Api(Description="Form - EarlyBirdForm")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.EarlyBirdFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdFormValidationResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdFormPostValidate implements IReturn<EarlyBirdFormValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the early bird form. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The early bird form to validate. */
    // @DataMember(Order=2)
    public data?: EarlyBirdForm;

    public constructor(init?: Partial<EarlyBirdFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EarlyBirdFormValidationResponse(); }
}

// @Route("/conference/form/registration/single/id/{Id}", "GET")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationGetSingleById implements IReturn<RegistrationSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the registration to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/conference/form/registration/collection", "GET")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationGetCollection implements IReturn<RegistrationCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<RegistrationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationCollectionResponse(); }
}

// @Route("/conference/form/registration/create", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostCreate implements IReturn<RegistrationSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the registration. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the registration. */
    // @DataMember(Order=2)
    public data?: Registration;

    public constructor(init?: Partial<RegistrationPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/conference/form/registration/save", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostSave implements IReturn<RegistrationSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the registration. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The registration to save. */
    // @DataMember(Order=2)
    public data?: Registration;

    public constructor(init?: Partial<RegistrationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationSingleResponse(); }
}

// @Route("/conference/form/registration/validate", "POST")
// @Api(Description="Form - Registration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationPostValidate implements IReturn<RegistrationValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the registration. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The registration to validate. */
    // @DataMember(Order=2)
    public data?: Registration;

    public constructor(init?: Partial<RegistrationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationValidationResponse(); }
}

// @Route("/conference/form/session/single/id/{Id}", "GET")
// @Api(Description="Form - Session")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=500)
// @DataContract
export class SessionGetSingleById implements IReturn<SessionSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the session to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SessionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SessionSingleResponse(); }
}

// @Route("/conference/form/session/collection", "GET")
// @Api(Description="Form - Session")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SessionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SessionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SessionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SessionCollectionResponse)", StatusCode=500)
// @DataContract
export class SessionGetCollection implements IReturn<SessionCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<SessionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SessionCollectionResponse(); }
}

// @Route("/conference/form/session/create", "POST")
// @Api(Description="Form - Session")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=500)
// @DataContract
export class SessionPostCreate implements IReturn<SessionSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the session. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the session. */
    // @DataMember(Order=2)
    public data?: Session;

    public constructor(init?: Partial<SessionPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SessionSingleResponse(); }
}

// @Route("/conference/form/session/save", "POST")
// @Api(Description="Form - Session")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SessionSingleResponse)", StatusCode=500)
// @DataContract
export class SessionPostSave implements IReturn<SessionSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the session. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The session to save. */
    // @DataMember(Order=2)
    public data?: Session;

    public constructor(init?: Partial<SessionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SessionSingleResponse(); }
}

// @Route("/conference/form/session/validate", "POST")
// @Api(Description="Form - Session")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SessionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SessionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SessionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SessionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SessionValidationResponse)", StatusCode=500)
// @DataContract
export class SessionPostValidate implements IReturn<SessionValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the session. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The session to validate. */
    // @DataMember(Order=2)
    public data?: Session;

    public constructor(init?: Partial<SessionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SessionValidationResponse(); }
}

// @Route("/conference/form/sponsor/single/id/{Id}", "GET")
// @Api(Description="Form - Sponsor")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=500)
// @DataContract
export class SponsorGetSingleById implements IReturn<SponsorSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the sponsor to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SponsorGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SponsorGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SponsorSingleResponse(); }
}

// @Route("/conference/form/sponsor/collection", "GET")
// @Api(Description="Form - Sponsor")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SponsorCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SponsorCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SponsorCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SponsorCollectionResponse)", StatusCode=500)
// @DataContract
export class SponsorGetCollection implements IReturn<SponsorCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<SponsorGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SponsorGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SponsorCollectionResponse(); }
}

// @Route("/conference/form/sponsor/create", "POST")
// @Api(Description="Form - Sponsor")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=500)
// @DataContract
export class SponsorPostCreate implements IReturn<SponsorSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the sponsor. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the sponsor. */
    // @DataMember(Order=2)
    public data?: Sponsor;

    public constructor(init?: Partial<SponsorPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SponsorPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SponsorSingleResponse(); }
}

// @Route("/conference/form/sponsor/save", "POST")
// @Api(Description="Form - Sponsor")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SponsorSingleResponse)", StatusCode=500)
// @DataContract
export class SponsorPostSave implements IReturn<SponsorSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the sponsor. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The sponsor to save. */
    // @DataMember(Order=2)
    public data?: Sponsor;

    public constructor(init?: Partial<SponsorPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SponsorPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SponsorSingleResponse(); }
}

// @Route("/conference/form/sponsor/validate", "POST")
// @Api(Description="Form - Sponsor")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SponsorValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SponsorValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SponsorValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SponsorValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SponsorValidationResponse)", StatusCode=500)
// @DataContract
export class SponsorPostValidate implements IReturn<SponsorValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the sponsor. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The sponsor to validate. */
    // @DataMember(Order=2)
    public data?: Sponsor;

    public constructor(init?: Partial<SponsorPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SponsorPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SponsorValidationResponse(); }
}

// @Route("/conference/form/plane-ticket/single/id/{Id}", "GET")
// @Api(Description="Form - PlaneTicket")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=500)
// @DataContract
export class PlaneTicketGetSingleById implements IReturn<PlaneTicketSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the plane ticket to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PlaneTicketGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PlaneTicketGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PlaneTicketSingleResponse(); }
}

// @Route("/conference/form/plane-ticket/collection", "GET")
// @Api(Description="Form - PlaneTicket")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PlaneTicketCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PlaneTicketCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PlaneTicketCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PlaneTicketCollectionResponse)", StatusCode=500)
// @DataContract
export class PlaneTicketGetCollection implements IReturn<PlaneTicketCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<PlaneTicketGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PlaneTicketGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PlaneTicketCollectionResponse(); }
}

// @Route("/conference/form/plane-ticket/create", "POST")
// @Api(Description="Form - PlaneTicket")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=500)
// @DataContract
export class PlaneTicketPostCreate implements IReturn<PlaneTicketSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the plane ticket. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the plane ticket. */
    // @DataMember(Order=2)
    public data?: PlaneTicket;

    public constructor(init?: Partial<PlaneTicketPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PlaneTicketPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PlaneTicketSingleResponse(); }
}

// @Route("/conference/form/plane-ticket/save", "POST")
// @Api(Description="Form - PlaneTicket")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PlaneTicketSingleResponse)", StatusCode=500)
// @DataContract
export class PlaneTicketPostSave implements IReturn<PlaneTicketSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the plane ticket. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The plane ticket to save. */
    // @DataMember(Order=2)
    public data?: PlaneTicket;

    public constructor(init?: Partial<PlaneTicketPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PlaneTicketPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PlaneTicketSingleResponse(); }
}

// @Route("/conference/form/plane-ticket/validate", "POST")
// @Api(Description="Form - PlaneTicket")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PlaneTicketValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PlaneTicketValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PlaneTicketValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PlaneTicketValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PlaneTicketValidationResponse)", StatusCode=500)
// @DataContract
export class PlaneTicketPostValidate implements IReturn<PlaneTicketValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the plane ticket. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The plane ticket to validate. */
    // @DataMember(Order=2)
    public data?: PlaneTicket;

    public constructor(init?: Partial<PlaneTicketPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PlaneTicketPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PlaneTicketValidationResponse(); }
}

// @Route("/conference/form/speaker-presentation/single/id/{Id}", "GET")
// @Api(Description="Form - SpeakerPresentation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=500)
// @DataContract
export class SpeakerPresentationGetSingleById implements IReturn<SpeakerPresentationSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the speaker presentation to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SpeakerPresentationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SpeakerPresentationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SpeakerPresentationSingleResponse(); }
}

// @Route("/conference/form/speaker-presentation/collection", "GET")
// @Api(Description="Form - SpeakerPresentation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SpeakerPresentationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SpeakerPresentationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SpeakerPresentationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SpeakerPresentationCollectionResponse)", StatusCode=500)
// @DataContract
export class SpeakerPresentationGetCollection implements IReturn<SpeakerPresentationCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<SpeakerPresentationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SpeakerPresentationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SpeakerPresentationCollectionResponse(); }
}

// @Route("/conference/form/speaker-presentation/create", "POST")
// @Api(Description="Form - SpeakerPresentation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=500)
// @DataContract
export class SpeakerPresentationPostCreate implements IReturn<SpeakerPresentationSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the speaker presentation. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the speaker presentation. */
    // @DataMember(Order=2)
    public data?: SpeakerPresentation;

    public constructor(init?: Partial<SpeakerPresentationPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SpeakerPresentationPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SpeakerPresentationSingleResponse(); }
}

// @Route("/conference/form/speaker-presentation/save", "POST")
// @Api(Description="Form - SpeakerPresentation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SpeakerPresentationSingleResponse)", StatusCode=500)
// @DataContract
export class SpeakerPresentationPostSave implements IReturn<SpeakerPresentationSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the speaker presentation. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The speaker presentation to save. */
    // @DataMember(Order=2)
    public data?: SpeakerPresentation;

    public constructor(init?: Partial<SpeakerPresentationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SpeakerPresentationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SpeakerPresentationSingleResponse(); }
}

// @Route("/conference/form/speaker-presentation/validate", "POST")
// @Api(Description="Form - SpeakerPresentation")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.SpeakerPresentationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.SpeakerPresentationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.SpeakerPresentationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.SpeakerPresentationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.SpeakerPresentationValidationResponse)", StatusCode=500)
// @DataContract
export class SpeakerPresentationPostValidate implements IReturn<SpeakerPresentationValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the speaker presentation. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The speaker presentation to validate. */
    // @DataMember(Order=2)
    public data?: SpeakerPresentation;

    public constructor(init?: Partial<SpeakerPresentationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SpeakerPresentationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SpeakerPresentationValidationResponse(); }
}

// @Route("/conference/form/early-bird-registration/single/id/{Id}", "GET")
// @Api(Description="Form - EarlyBirdRegistration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdRegistrationGetSingleById implements IReturn<EarlyBirdRegistrationSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the early bird registration to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EarlyBirdRegistrationGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdRegistrationGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EarlyBirdRegistrationSingleResponse(); }
}

// @Route("/conference/form/early-bird-registration/collection", "GET")
// @Api(Description="Form - EarlyBirdRegistration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationCollectionResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdRegistrationGetCollection implements IReturn<EarlyBirdRegistrationCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<EarlyBirdRegistrationGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdRegistrationGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EarlyBirdRegistrationCollectionResponse(); }
}

// @Route("/conference/form/early-bird-registration/create", "POST")
// @Api(Description="Form - EarlyBirdRegistration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdRegistrationPostCreate implements IReturn<EarlyBirdRegistrationSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the early bird registration. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the early bird registration. */
    // @DataMember(Order=2)
    public data?: EarlyBirdRegistration;

    public constructor(init?: Partial<EarlyBirdRegistrationPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdRegistrationPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EarlyBirdRegistrationSingleResponse(); }
}

// @Route("/conference/form/early-bird-registration/save", "POST")
// @Api(Description="Form - EarlyBirdRegistration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationSingleResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdRegistrationPostSave implements IReturn<EarlyBirdRegistrationSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the early bird registration. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The early bird registration to save. */
    // @DataMember(Order=2)
    public data?: EarlyBirdRegistration;

    public constructor(init?: Partial<EarlyBirdRegistrationPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdRegistrationPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EarlyBirdRegistrationSingleResponse(); }
}

// @Route("/conference/form/early-bird-registration/validate", "POST")
// @Api(Description="Form - EarlyBirdRegistration")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.EarlyBirdRegistrationValidationResponse)", StatusCode=500)
// @DataContract
export class EarlyBirdRegistrationPostValidate implements IReturn<EarlyBirdRegistrationValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the early bird registration. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The early bird registration to validate. */
    // @DataMember(Order=2)
    public data?: EarlyBirdRegistration;

    public constructor(init?: Partial<EarlyBirdRegistrationPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EarlyBirdRegistrationPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EarlyBirdRegistrationValidationResponse(); }
}

// @Route("/conference/form/payment/single/id/{Id}", "GET")
// @Api(Description="Form - Payment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=500)
// @DataContract
export class PaymentGetSingleById implements IReturn<PaymentSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the payment to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PaymentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaymentSingleResponse(); }
}

// @Route("/conference/form/payment/collection", "GET")
// @Api(Description="Form - Payment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PaymentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PaymentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PaymentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PaymentCollectionResponse)", StatusCode=500)
// @DataContract
export class PaymentGetCollection implements IReturn<PaymentCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<PaymentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaymentCollectionResponse(); }
}

// @Route("/conference/form/payment/create", "POST")
// @Api(Description="Form - Payment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=500)
// @DataContract
export class PaymentPostCreate implements IReturn<PaymentSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the payment. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the payment. */
    // @DataMember(Order=2)
    public data?: Payment;

    public constructor(init?: Partial<PaymentPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaymentSingleResponse(); }
}

// @Route("/conference/form/payment/save", "POST")
// @Api(Description="Form - Payment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PaymentSingleResponse)", StatusCode=500)
// @DataContract
export class PaymentPostSave implements IReturn<PaymentSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the payment. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The payment to save. */
    // @DataMember(Order=2)
    public data?: Payment;

    public constructor(init?: Partial<PaymentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PaymentSingleResponse(); }
}

// @Route("/conference/form/payment/validate", "POST")
// @Api(Description="Form - Payment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.PaymentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.PaymentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.PaymentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.PaymentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.PaymentValidationResponse)", StatusCode=500)
// @DataContract
export class PaymentPostValidate implements IReturn<PaymentValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the payment. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The payment to validate. */
    // @DataMember(Order=2)
    public data?: Payment;

    public constructor(init?: Partial<PaymentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PaymentValidationResponse(); }
}

// @Route("/conference/form/registration-cancellation-list/single/id/{Id}", "GET")
// @Api(Description="Form - RegistrationCancellationList")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationCancellationListGetSingleById implements IReturn<RegistrationCancellationListSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the registration cancellation list to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationCancellationListGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationCancellationListGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationCancellationListSingleResponse(); }
}

// @Route("/conference/form/registration-cancellation-list/collection", "GET")
// @Api(Description="Form - RegistrationCancellationList")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationCancellationListGetCollection implements IReturn<RegistrationCancellationListCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<RegistrationCancellationListGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationCancellationListGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationCancellationListCollectionResponse(); }
}

// @Route("/conference/form/registration-cancellation-list/create", "POST")
// @Api(Description="Form - RegistrationCancellationList")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationCancellationListPostCreate implements IReturn<RegistrationCancellationListSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the registration cancellation list. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the registration cancellation list. */
    // @DataMember(Order=2)
    public data?: RegistrationCancellationList;

    public constructor(init?: Partial<RegistrationCancellationListPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationCancellationListPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationCancellationListSingleResponse(); }
}

// @Route("/conference/form/registration-cancellation-list/save", "POST")
// @Api(Description="Form - RegistrationCancellationList")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationCancellationListPostSave implements IReturn<RegistrationCancellationListSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the registration cancellation list. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The registration cancellation list to save. */
    // @DataMember(Order=2)
    public data?: RegistrationCancellationList;

    public constructor(init?: Partial<RegistrationCancellationListPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationCancellationListPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationCancellationListSingleResponse(); }
}

// @Route("/conference/form/registration-cancellation-list/validate", "POST")
// @Api(Description="Form - RegistrationCancellationList")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationCancellationListValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationCancellationListPostValidate implements IReturn<RegistrationCancellationListValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the registration cancellation list. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The registration cancellation list to validate. */
    // @DataMember(Order=2)
    public data?: RegistrationCancellationList;

    public constructor(init?: Partial<RegistrationCancellationListPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationCancellationListPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationCancellationListValidationResponse(); }
}

// @Route("/conference/form/registration-session/single/id/{Id}", "GET")
// @Api(Description="Form - RegistrationSession")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationSessionGetSingleById implements IReturn<RegistrationSessionSingleResponse>, IDataGetSingleById
{
    [immerable] = true;
    /** @description The ID of the registration session to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationSessionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationSessionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationSessionSingleResponse(); }
}

// @Route("/conference/form/registration-session/collection", "GET")
// @Api(Description="Form - RegistrationSession")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationSessionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationSessionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationSessionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationSessionCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationSessionGetCollection implements IReturn<RegistrationSessionCollectionResponse>, IDataGetCollection
{
    [immerable] = true;
    /** @description The number of entries to skip. */
    // @DataMember(Order=1)
    public skip?: number;

    /** @description The number of entries to return. */
    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<RegistrationSessionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationSessionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationSessionCollectionResponse(); }
}

// @Route("/conference/form/registration-session/create", "POST")
// @Api(Description="Form - RegistrationSession")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationSessionPostCreate implements IReturn<RegistrationSessionSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the registration session. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The values to prefill on the registration session. */
    // @DataMember(Order=2)
    public data?: RegistrationSession;

    public constructor(init?: Partial<RegistrationSessionPostCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationSessionPostCreate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationSessionSingleResponse(); }
}

// @Route("/conference/form/registration-session/save", "POST")
// @Api(Description="Form - RegistrationSession")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationSessionSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationSessionPostSave implements IReturn<RegistrationSessionSingleResponse>
{
    [immerable] = true;
    /** @description The metadata to use when creating the registration session. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The registration session to save. */
    // @DataMember(Order=2)
    public data?: RegistrationSession;

    public constructor(init?: Partial<RegistrationSessionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationSessionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationSessionSingleResponse(); }
}

// @Route("/conference/form/registration-session/validate", "POST")
// @Api(Description="Form - RegistrationSession")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Forms.Form.RegistrationSessionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Forms.Form.RegistrationSessionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Forms.Form.RegistrationSessionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Forms.Form.RegistrationSessionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Forms.Form.RegistrationSessionValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationSessionPostValidate implements IReturn<RegistrationSessionValidationResponse>
{
    [immerable] = true;
    /** @description The metadata to use when validating the registration session. */
    // @DataMember(Order=1)
    public metadata?: { [index: string]: Object; };

    /** @description The registration session to validate. */
    // @DataMember(Order=2)
    public data?: RegistrationSession;

    public constructor(init?: Partial<RegistrationSessionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationSessionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationSessionValidationResponse(); }
}

// @Route("/conference/file/view/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/conference/file/download/{Id}", "GET")
export class DownloadFile implements IReturn<Blob>, IGet
{
    [immerable] = true;
    public id?: number;

    public constructor(init?: Partial<DownloadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

